import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

import IwLink from '../../iwRouter/IwLink';

type Props = {
    to: string;
    isActive?: boolean;
    'data-testid'?: string;
    children: React.ReactNode;
};

export const NavLink = ({
    to,
    isActive,
    'data-testid': dataTestId,
    children
}: Props) => (
    <IwLink
        data-testid={dataTestId}
        to={to}
        className={twMerge(
            classNames(
                'my-xs pb-s hover:underline hover:decoration-2 hover:underline-offset-2',
                {
                    'underline decoration-2 underline-offset-2': isActive
                }
            )
        )}
    >
        {children}
    </IwLink>
);
